module.exports = __webpack_public_path__ + "static/media/19ESCAP40.7ed784fd.jpg";